module.exports = __webpack_public_path__ + "static/img/leaveInformation.b70055c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/leaveInformation.png
// module id = tUDC
// module chunks = 1